import React from 'react';
import ContainerHeader from 'components/ContainerHeader/index';
import SiteTraffic from 'components/toliton/desktop/siteTraffic/siteTraffic';
import LatestOrders from 'components/toliton/desktop/latestOrders/latestOrders';
import TimerView from 'components/toliton/desktop/TimerView/index';

import FavoriteProducts from 'components/toliton/desktop/products/favoriteProducts';
import FavoriteProducers from 'components/toliton/desktop/producers/favoriteProducers';

class Desktop extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <ContainerHeader match={this.props.match} title="میز کار"/>

                <SiteTraffic/>

                <div className="row">
                    <div className="col-lg-9">
                        <LatestOrders/>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12 order-lg-3">
                        <TimerView headerColor="secondary"/>
                    </div>

                </div>

                <div className="row">
                    <div className="col-lg-8 col-sm-12">
                        <FavoriteProducts/>
                    </div>
                    <div className="col-lg-4 col-sm-12">
                        <FavoriteProducers/>
                    </div>
                </div>

            </div>
        )
    }

}

export default Desktop;




// WEBPACK FOOTER //
// ./app/routes/toliton/desktop/desktop.js